import type { Router } from 'next/router';
import URI from 'urijs';
import { windowWrapper } from '@clubmed/utils';
import DynamicLinkUtil from 'Components/frameworks/dynamic-link/DynamicLinkUtil';
import { clearAllCacheFront } from 'Utils/graphql-client/cacheFront';
import { buildSellerSigninUrl, buildSigninUrl } from 'Utils/ple-utils';
export function redirectToUri(router: Router): (arg0: string) => () => void {
  return (uri: string): (() => void) => {
    return (): void => {
      const redirectUri = new DynamicLinkUtil(windowWrapper.getLocation(), uri).toString();
      router.push(redirectUri);
    };
  };
}
export function redirectToOidc(appContext: AppContext, redirectUrl?: string) {
  const { locale, isSeller, isCmta } = appContext;

  if (typeof window !== 'undefined') {
    const currentLocation = new URI(windowWrapper.getLocation()).removeSearch('forceAuth');
    const redirectPath = redirectUrl || currentLocation.pathname();
    const redirectUri = new URI(windowWrapper.getOrigin())
      .path(redirectPath)
      .query(currentLocation.search())
      .hash(windowWrapper.getLocationPart('hash'))
      .toString();
    clearAllCacheFront();
    windowWrapper.setLocation(
      isSeller
        ? buildSellerSigninUrl({
            locale,
            redirectUri,
            isCmta,
          })
        : buildSigninUrl({
            locale,
            redirectUri,
          }),
    );
  }
}
